var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.game)?_c('div',{staticClass:"game-play-page page-container"},[_c('div',{staticClass:"play-header"},[_c('span',[_vm._v(_vm._s(_vm.game.name))]),_c('el-button',{attrs:{"type":"text","icon":"el-icon-close"},on:{"click":_vm.closePage}},[_vm._v("关闭游戏")])],1),_c(_vm.game.component,{tag:"component",staticClass:"play-stage"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }